import { useSelector, useDispatch } from 'react-redux';
import IconTooltipButton from './IconTooltipButton';
import ButtonStartIcon from './ButtonStartIcon';
import { toggleAlertModule } from '../../store/actions/alert.actions';

/**
 * Common component, Button Fab Icon with Tooltip
 @param {String} icon Icon FontAwesome 
 @param {String} title title tooltip
 @param {String} submodule module alert
 @param {Boolean} disabled disabled buttom
 @param {String} className class name button
 @param {Function} onDontSave event dont save alert
 */

const AlertSaveButton = ({ icon, title, submodule = 'Maestro', disabled, className, classNameIcon, onDontSave, type, color, variant, style }) => {
  const dispatch = useDispatch()
  const alertSave = useSelector(state => state?.alert?.save || {})

  const handleDontSave = () => {
    if (onDontSave) {
      onDontSave()
    }
  }

  const handleClick = () => {
    if (alertSave && alertSave.mode) {
      dispatch(toggleAlertModule(
        true,
        submodule,
        alertSave.mode,
        alertSave.onSave,
        () => {
          handleDontSave()
        }
      ))
    } else {
      handleDontSave()
    }
  }

  if (type === 'icon') {
    return (
      <IconTooltipButton
        title={title}
        disabled={disabled}
        icon={icon}
        className={className}
        classNameIcon={classNameIcon}
        onClick={handleClick} 
        color={color}
      />
    )
  }
  
  return (
    <ButtonStartIcon
      disabled={disabled}
      className={className}
      style={style}
      onClick={handleClick}
      startIcon={icon}
      color={color}
      variant={variant}
    >
      {title}
    </ButtonStartIcon>
    )
  }
  
  export default AlertSaveButton